module.exports = __webpack_public_path__ + "img/il-sorpasso-logo.514270a3.jpg";